import { render } from "./InputDateTime.vue?vue&type=template&id=56d16e85"
import script from "./InputDateTime.vue?vue&type=script&lang=js"
export * from "./InputDateTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__